import { kaiaWallet, kaikasWallet, metaMaskWallet, walletConnectWallet } from '@lair-finance/wallet/wallets'
import { Chains, SupportedChains } from '@/domains/chain'
import { createClient } from 'viem'
import { createConfig, http, injected } from '@lair-finance/wagmi/core'
import { connectorsForWallets } from '@lair-finance/wallet'
import { WagmiProvider as BaseWagmiProvider } from '@lair-finance/wagmi'
import { dappPortalConnectorId, walletProvider } from '@/modules/game/shared/lib/sdk/dapp-portal'
import { type CreateConnectorFn } from '@lair-finance/wagmi'
import { isDevelopment } from '@/shared/constants/env.ts'
import { IS_INJECTIVE_TEST_SERVER } from '@/shared/config'

export let wagmiConfig: ReturnType<typeof createConfig>

const projectId = 'b2847a1b3ccf425f137ad0d88562c5a9'

const baseConnectors: CreateConnectorFn[] = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: IS_INJECTIVE_TEST_SERVER ? [walletConnectWallet, metaMaskWallet] : [walletConnectWallet, kaikasWallet, kaiaWallet, metaMaskWallet],
    },
  ],
  {
    appName: 'Lair Finance',
    projectId,
  },
)

export async function initializeWagmiConfig() {
  wagmiConfig = createConfig({
    connectors: baseConnectors,
    chains: SupportedChains,
    ssr: false,
    client: ({ chain }) => createClient({ chain, transport: http() }),
  })

  console.log('WagmiConfig initialized')
}

export async function initializeWagmiConfigWithDappPortal() {
  if (!walletProvider) {
    throw new Error('WalletProvider is not initialized. Call initializeWallet first.')
  }

  wagmiConfig = createConfig({
    connectors: [
      ...baseConnectors,
      injected({
        target() {
          return {
            id: dappPortalConnectorId,
            name: 'Dapp Portal',
            provider: walletProvider as any,
          }
        },
      }),
    ],
    chains: isDevelopment ? [Chains.KAIA_TESTNET, Chains.BERA_TESTNET] : [Chains.KAIA, Chains.BERA],
    ssr: false,
    client: ({ chain }) => createClient({ chain, transport: http() }),
  })

  console.log('WagmiConfigWithDappPortal initialized')
}

export function WagmiProvider({ children }: { children: React.ReactNode }) {
  if (!wagmiConfig) {
    throw new Error('WagmiConfig is not initialized. Call initializeWagmiConfig first.')
  }

  return <BaseWagmiProvider config={wagmiConfig}>{children}</BaseWagmiProvider>
}
